import { createAction } from '@reduxjs/toolkit';
import { ACT_SET, MN_TIMESHEET_LOCK, TYPE_ELEMENT } from '../../../../common';
import { ITimesheetLock } from '../../../../dto';

export const setTimesheetLock = createAction<ITimesheetLock>(
  `${MN_TIMESHEET_LOCK}/${TYPE_ELEMENT}/${ACT_SET}`,
);
